export default {
  queue: [],
  years: [],
  makes: [],
  languages: [],
  status: '',
  answer: ''
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/dispatch/state.js